/**
 * Generated by orval v8.20.0 🍺
 * Do not edit manually.
 * Cloud Drive
 * In the documentation API requests will be sent from currently logged in user so you do not need to provide a bearer token manually. <br><br> When calling API from outside the documentation, you will need to provide an access token for all requests in authorization header: `Authorization: Bearer <Token>` <br> You can create a new access token in your account settings page.
 * OpenAPI spec version: 1.0.0
 */
import type {CreateAccessTokenBody} from './schemas/create-access-token-body';

import type {CreateAccessToken200} from './schemas/create-access-token200';

import type {GetAccountSettings200} from './schemas/get-account-settings200';

import type {ListUserSessions200} from './schemas/list-user-sessions200';

import type {LogoutOtherSessionsBody} from './schemas/logout-other-sessions-body';

import {orvalApiFetch} from '../../../common/foundation/resources/client/http/query-client';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary Get account settings
 */
export const getAccountSettings = (
  options?: SecondParameter<typeof orvalApiFetch<GetAccountSettings200>>,
) => {
  return orvalApiFetch<GetAccountSettings200>(
    {url: `/account-settings`, method: 'GET'},
    options,
  );
};
/**
 * @summary Create access token
 */
export const createAccessToken = (
  createAccessTokenBody: CreateAccessTokenBody,
  options?: SecondParameter<typeof orvalApiFetch<CreateAccessToken200>>,
) => {
  return orvalApiFetch<CreateAccessToken200>(
    {
      url: `/access-tokens`,
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      data: createAccessTokenBody,
    },
    options,
  );
};
/**
 * @summary Delete access token
 */
export const deleteAccessToken = (
  tokenId: number,
  options?: SecondParameter<typeof orvalApiFetch<void>>,
) => {
  return orvalApiFetch<void>(
    {url: `/access-tokens/${tokenId}`, method: 'DELETE'},
    options,
  );
};
/**
 * @summary List user's sessions
 */
export const listUserSessions = (
  options?: SecondParameter<typeof orvalApiFetch<ListUserSessions200>>,
) => {
  return orvalApiFetch<ListUserSessions200>(
    {url: `/user-sessions`, method: 'GET'},
    options,
  );
};
/**
 * This will logout all the devices except the current one.
 * @summary Logout other sessions
 */
export const logoutOtherSessions = (
  logoutOtherSessionsBody: LogoutOtherSessionsBody,
  options?: SecondParameter<typeof orvalApiFetch<void>>,
) => {
  return orvalApiFetch<void>(
    {
      url: `/user-sessions/logout-other`,
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      data: logoutOtherSessionsBody,
    },
    options,
  );
};
export type GetAccountSettingsResult = NonNullable<
  Awaited<ReturnType<typeof getAccountSettings>>
>;
export type CreateAccessTokenResult = NonNullable<
  Awaited<ReturnType<typeof createAccessToken>>
>;
export type DeleteAccessTokenResult = NonNullable<
  Awaited<ReturnType<typeof deleteAccessToken>>
>;
export type ListUserSessionsResult = NonNullable<
  Awaited<ReturnType<typeof listUserSessions>>
>;
export type LogoutOtherSessionsResult = NonNullable<
  Awaited<ReturnType<typeof logoutOtherSessions>>
>;
